import React from 'react';
import { Typography, Box, Divider, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
const Map = () => {
  const { t } = useTranslation();
  return (
<div style={{flexDirection: 'column',display: 'flex',width: '100%',minWidth: '100%', height: '100%', backgroundColor: 'white',border: '0',justifyContent: 'center',alignItems: 'center',}}>
<Typography
              variant="h2"
              component="div"
              sx={{
                marginTop: 5,
                color: "#000000",
                fontWeight: 700,
                fontSize: { xs: "2rem", md: "2.5rem" },
                position: "relative",
                fontFamily: "Montserrat",
              }}
            >
              {t('Titles.our_location')}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                paddingTop: "20px",
              }}
            >
              <Divider
                sx={{
                  backgroundColor: "primary.main",
                  width: "10vh",
                  height: "2px",
                }}
              />
            </Box>
            <Typography
              // variant="h6"
              component="div"
              sx={{
                marginTop: 5,
                color: "#000000",
                fontWeight: 700,
                fontSize: { xs: "1rem", md: "1.5rem" },
                position: "relative",
                fontFamily: "Noto Sans",
              }}
            >
              {t('Titles.Aqaba')}
            </Typography>
<Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                paddingTop: "20px",
              }}
            >
              <Divider
                sx={{
                  backgroundColor: "primary.main",
                  width: "10vh",
                  height: "2px",
                }}
              />
            </Box>
            <Container sx={{
  position: "relative",
  width: { xs: "98%", md: "60%" }, 
  height: "60vh", /* 60% of the viewport height */
  borderRadius: "2rem",
  margin: "20px",
  border: "1px solid #13294b",
  overflow: "hidden"
}}>
  <iframe
    title="Google Maps Location"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4118.113299018426!2d35.00512232395907!3d29.52534834297786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x150071916513ecc5%3A0x9fbffba2a61f87cf!2z2YbZitix2YjYriDZhNmE2LPZgdixINmI2KfZhNiz2YrYp9it2KkgLSBuYWlyb3VraCBmb3IgdHJhdmVsICYgdG91cmlz!5e1!3m2!1sar!2sjo!4v1742843129772!5m2!1sar!2sjo"
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "2rem"
    }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</Container>
<Typography
              // variant="h6"
              component="div"
              sx={{
                marginTop: 5,
                color: "#000000",
                fontWeight: 700,
                fontSize: { xs: "1rem", md: "1.5rem" },
                position: "relative",
                fontFamily: "Noto Sans, sans-serif",
              }}
            >
              {t('Titles.Amman')}
            </Typography>
<Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                paddingTop: "20px",
              }}
            >
              <Divider
                sx={{
                  backgroundColor: "primary.main",
                  width: "10vh",
                  height: "2px",
                }}
              />
            </Box>{" "}
<Container sx={{
  position: "relative",
  width: { xs: "98%", md: "60%" }, 
  height: "60vh", /* 60% of the viewport height */
  borderRadius: "2rem",
  margin: "20px",
  border: "1px solid #13294b",
  overflow: "hidden"
}}>
  <iframe
    title="Google Maps Location"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4016.9916360961606!2d35.94100162388931!3d31.921727927202102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151b5f49d18a22a5%3A0x505222c288550cc8!2z2YbZitix2YjYriDZhNmE2LPZitin2K3YqSDZiNin2YTYs9mB2LE!5e1!3m2!1sar!2sjo!4v1743016451815!5m2!1sar!2sjo"     style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "2rem"
    }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</Container>

    </div>
  );
};

export default Map;
